import { ReconciliationSku } from 'modules/domain/reconciliation/types'

export const mapReconciliationItem = (raw: ReconciliationSku, id: string): ReconciliationSku => ({
  ...raw,
  id,
  sku_id: raw.id,
})
